module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "email.it",
  "libero.it",
  "yahoo.it"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/internet/free_email.js
 ** module id = 773
 ** module chunks = 0
 **/